import * as React from 'react';
import { AppBar, Box, Stack, Toolbar, Tooltip, Avatar, Button } from '@mui/material';
import { IconButton, Typography, } from '@mui/material';
import { Link, useNavigate } from "react-router-dom";
import { useTheme } from '@mui/material/styles';

import AppContext from '../AppContext';
import { AuthRequiredComponent } from './Auth'
import { pb } from '../utilities/pocketbase';

import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';

import CRRaoAIMSCSLogo from '../crrao_aimscs_logo-min.png'

import { ShowDateTime } from './ShowDateTime';

export default function NavBar({ type = "menu" }) {
    const theme = useTheme()
    const [appState, appStateDispatch] = React.useContext(AppContext)
    const [currentTime, setCurrentTime] = React.useState(new Date())

    const navigate = useNavigate()

    const toggleThemeClick = () => {
        appStateDispatch({ type: 'toggleTheme' })
        // closeSettingsMenu()
    }

    React.useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date())
        }, 1000);

        return () => clearInterval(timer)
    }, [])

    return (
        <Box>
            <AppBar position="relative" color='transparent' className="navbar" sx={{ boxShadow: 0, backdropFilter: "blur(20px)", borderBottom: 1, borderColor: "divider" }}>
                <Toolbar sx={{ ...(false && { borderBottom: 1, borderColor: "text.disabled" }) }}>
                    <MainLogo />

                    <Box sx={{ flexGrow: 1 }} />

                    <AuthRequiredComponent>
                        {pb?.authStore?.model?.id && <Button onClick={() => { pb.authStore.clear(); navigate("/") }}
                            sx={{ color: 'text.secondary', mr: { xs: 0, md: 2 }, textTransform: 'none', borderRadius: 5, px: 2 }}>
                            Logout
                        </Button>}
                    </AuthRequiredComponent>
                    {/* {pb.authStore.model.id && <Button sx={{ borderRadius: 5, px: 2, textTransform: "none" }} color='text.secondary' onClick={() => pb.authStore.clear()}>Logout</Button>} */}

                    <Stack direction={"row"} spacing={0.5} alignItems={"center"} justifyContent={"flex-end"}>
                        <ShowDateTime currentTime={currentTime} />
                        <Tooltip title="theme"><IconButton color={({ 'dark': undefined, 'light': "warning" }[theme.palette.mode])} onClick={toggleThemeClick}>{({ 'dark': <DarkModeOutlinedIcon />, 'light': <LightModeOutlinedIcon /> }[theme.palette.mode])}</IconButton></Tooltip>
                    </Stack>
                </Toolbar>
            </AppBar>
        </Box>
    )
}

function MainLogo() {
    // console.log("LOGO-LOADED!")

    return (
        <Stack direction={"row"} justifyContent={"center"} alignItems={"center"} color={"inherit"} sx={{ textDecoration: "none" }}
            component={Link} to="/"
        >
            <Avatar variant='rounded' sx={{ mr: 1 }} src={CRRaoAIMSCSLogo} />
            <Stack spacing={-1} justifyContent={"center"} alignItems={"flex-start"} direction={"column"}>
                <Typography variant='caption' fontFamily={"JetBrains Mono"} sx={{ fontWeight: "bold" }}>STATISTICS</Typography>
                <Typography variant='subtitle1' fontFamily={"JetBrains Mono"} sx={{ fontWeight: "bold" }}>OLYMPIAD 2024</Typography>
            </Stack>
        </Stack>
    )
}